<div class="container p-4 bg-whitesmoke">
  <app-breadcrumb [activePanel]="'gallery'"></app-breadcrumb>
  
  <!-- Upload Button -->
  <div class="d-flex justify-content-end mb-3">
    <button mat-raised-button color="primary" (click)="openUploadDialog()"
    [disabled]="galleryImages.length >= maxImages"
      class="d-flex align-items-center">
      <mat-icon class="me-2">add_photo_alternate</mat-icon>
      Upload Images
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="mt-3 text-muted">Loading gallery images...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="alert alert-danger rounded">
    <div class="d-flex align-items-center">
      <mat-icon class="me-2">error</mat-icon>
      <div>
        <h6 class="mb-1">Error Loading Gallery</h6>
        <p class="mb-3">{{ error }}</p>
        <button mat-button color="primary" (click)="fetchGalleryImages()">
          <mat-icon class="me-1">refresh</mat-icon>
          Try Again
        </button>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && galleryImages.length === 0" class="text-center py-5">
    <div class="mb-4">
      <mat-icon class="display-1 text-muted">photo_library</mat-icon>
    </div>
    <h4 class="fw-bold">No Images Found</h4>
    <p class="text-muted mb-4">Upload your first images to get started</p>
    <button mat-raised-button color="accent" (click)="openUploadDialog()">
      <mat-icon class="me-2">add_photo_alternate</mat-icon>
      Upload Your First Images
    </button>
  </div>

  <!-- Gallery Content -->
  <div *ngIf="!loading && !error && galleryImages.length > 0">
    <!-- View Toggle -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
      <mat-button-toggle-group [(value)]="viewMode" appearance="standard" class="shadow-sm">
        <mat-button-toggle value="grid">
          <mat-icon class="me-1">grid_view</mat-icon>
          Grid View
        </mat-button-toggle>
        <mat-button-toggle value="list">
          <mat-icon class="me-1">view_list</mat-icon>
          List View
        </mat-button-toggle>
      </mat-button-toggle-group>
      <div class="mt-3 mt-md-0">
        <span class="badge fs-6 p-2" style="background: #ff6f61; color: #fff;">
          {{ galleryImages.length }} {{ galleryImages.length === 1 ? 'Image' : 'Images' }}
        </span>
      </div>
    </div>

    <!-- Grid View -->
    <div *ngIf="viewMode === 'grid'" class="row">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
           *ngFor="let image of galleryImages; trackBy: trackByImageUrl">
       <mat-card class="shadow-sm border-0 hover-shadow transition-all text-center"
          style="border-radius: 8px; background: #fff; padding: 12px;">
  <!-- Square Thumbnail -->
  <div class="square-container mb-2">
    <img [src]="image.imageUrl"
         alt="Gallery Image"
         style="cursor: pointer; width: 100%; height: 100%; object-fit: cover;"
         (click)="openImageModal(image.imageUrl)">
  </div>

  <!-- Delete button directly under the image -->
  <button mat-icon-button color="warn"
          (click)="deleteImage(image.imageUrl)"
          matTooltip="Delete Image">
    <mat-icon>delete</mat-icon>
  </button>
</mat-card>
      </div>
    </div>

    <!-- List View -->
    <div *ngIf="viewMode === 'list'" class="d-flex flex-column gap-3">
      <mat-card class="shadow-sm border-0 hover-shadow transition-all"
                *ngFor="let image of galleryImages; trackBy: trackByImageUrl"
                style="border-radius: 8px; background: #fff;">
        <mat-card-content class="p-0">
          <div class="row g-0">
            <div class="col-12 col-md-4">
              <div class="ratio ratio-1x1 overflow-hidden">
                <img [src]="image.imageUrl" alt="Gallery Image"
                     class="w-100 h-100 object-fit-cover"
                     style="cursor: pointer;"
                     (click)="openImageModal(image.imageUrl)">
              </div>
            </div>
            <div class="col-12 col-md-8 d-flex align-items-center p-3">
              <div class="w-100">
                <div class="d-flex justify-content-between align-items-center">
                  <small class="text-muted"></small>
                  <button mat-icon-button color="warn"
                          (click)="deleteImage(image.imageUrl)"
                          matTooltip="Delete Image">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Bulk Actions -->
    <div class="mt-4 d-flex justify-content-end gap-2">
      <button mat-stroked-button color="warn"
              (click)="confirmDeleteAll()"
              [disabled]="galleryImages.length === 0">
        <mat-icon class="me-2">delete_sweep</mat-icon>
        Delete All Images
      </button>
    </div>
  </div>

  <!-- Upload Dialog -->
  <div *ngIf="showUploadDialog"
       class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-overlay"
       style="background: rgba(0, 0, 0, 0.6); z-index: 9999;">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          <mat-card class="shadow-lg border-0" style="border-radius: 12px; max-height: 90vh; background: #e3f2fd;">
            <mat-card-header class="d-flex justify-content-between align-items-center border-bottom px-4 py-3"
                            style="background: #bbdefb;">
              <mat-card-title class="fw-bold">
                <mat-icon class="me-2 text-primary">cloud_upload</mat-icon>
                Upload Images
              </mat-card-title>
              <button mat-icon-button (click)="closeUploadDialog()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>

            <mat-card-content class="px-4 py-4 overflow-auto" style="max-height: 65vh;">
              <div class="text-center mb-4">
                <div class="upload-area border-dashed border-2 rounded p-5"
                     [class.border-primary]="isDragging"
                     (dragover)="onDragOver($event)"
                     (dragleave)="onDragLeave($event)"
                     (drop)="onDrop($event)"
                     style="cursor: pointer;"
                     (click)="fileInput.click()">
                  <input type="file" #fileInput
                         (change)="onFileSelected($event)"
                         multiple accept="image/*"
                         style="display: none;">
                  <mat-icon class="display-3 text-primary mb-3">cloud_upload</mat-icon>
                  <h5 class="mb-2">Drag & Drop Images Here</h5>
                  <p class="text-muted mb-0">or click to browse files</p>
                  <small class="text-muted">Supports: JPG, PNG, WEBP</small>
                </div>
              </div>

              <!-- File Previews -->
              <div *ngIf="selectedFiles.length > 0" class="mt-4">
                <h6 class="mb-3">Selected Files ({{ selectedFiles.length }})</h6>
                <div class="row g-3">
                  <div *ngFor="let file of selectedFiles; let i = index" class="col-6 col-md-4 col-lg-3">
                    <div class="border rounded overflow-hidden position-relative" style="height: 150px;">
                      <img [src]="getFilePreview(file)" alt="Preview"
                           class="w-100 h-100 object-fit-cover">
                      <div class="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                           style="width: 24px; height: 24px; cursor: pointer;"
                           (click)="removeFile(i)">
                        <mat-icon class="small">close</mat-icon>
                      </div>
                      <div class="position-absolute bottom-0 start-0 end-0 bg-dark bg-opacity-75 text-white small p-1">
                        {{ file.name | truncate:15 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Upload Progress -->
              <div *ngIf="uploading" class="mt-4">
                <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
                <div class="text-center mt-2">
                  <small>Uploading {{ uploadedCount }} of {{ selectedFiles.length }} images...</small>
                </div>
              </div>
            </mat-card-content>

            <mat-card-actions class="d-flex justify-content-end gap-3 px-4 py-3 border-top bg-light"
                              style="border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
              <button mat-button (click)="closeUploadDialog()" class="px-4">Cancel</button>
              <button mat-raised-button color="primary"
                      (click)="uploadImages()"
                      [disabled]="selectedFiles.length === 0 || uploading"
                      class="px-4">
                <div class="d-flex align-items-center">
                  <mat-spinner *ngIf="uploading" diameter="20" class="me-2"></mat-spinner>
                  <mat-icon *ngIf="!uploading" class="me-2">cloud_upload</mat-icon>
                  <span>{{ uploading ? "Uploading..." : "Upload Images" }}</span>
                </div>
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <!-- Image Viewer Modal -->
  <div *ngIf="showImageModal" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
       style="background: rgba(0,0,0,0.9); z-index: 10001;" (click)="closeImageModal()">
    <div class="bg-white rounded shadow-lg position-relative"
         style="max-width: 95vw; max-height: 95vh; min-width: 80vw;"
         (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
        <h5 class="mb-0 fw-bold">Image Preview</h5>
        <button class="btn btn-close" (click)="closeImageModal()"></button>
      </div>

      <div class="text-center p-3" style="background: #f8f9fa;">
        <img [src]="currentImageUrl" alt="Full Size Image"
             class="img-fluid rounded shadow-sm"
             style="max-height: 70vh; max-width: 100%; object-fit: contain;">
      </div>

      <div class="p-3 border-top bg-light text-end">
        <button class="btn btn-secondary" (click)="closeImageModal()">Close</button>
      </div>
    </div>
  </div>
</div>